import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import Confirm from 'react-confirm-bootstrap';
import { flowRight as compose } from 'lodash';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import CustomPagination from '../../CustomPagination';
import CommonTable from '../../CommonTable/CommonTable';
import Loader from '../../Loader/Loader';

import { removeListing } from '../../../actions/siteadmin/ListingManagement/removeListing';
import { addListToRecommended, removeListFromRecommended } from '../../../actions/siteadmin/ListingManagement/manageRecommend';
import { changeFilterSettings } from '../../../actions/siteadmin/ManageListings/manageListingData';
import messages from '../../../locale/messages';
import { withQuery } from '../../../hoc/withGraphql';
import listingsQuery from './listingsQuery.graphql';
import { demoRestriction, demoRestrictionEncode } from '../../../helpers/DemoRestriction/demoRestriction';
import { censorEmail } from '../../../helpers/secureEmail';
import { decode } from '../../../helpers/queryEncryption';

import s from './ListingManagement.css';
class ListingManagement extends React.Component {

  static propTypes = {
    getAllListings: PropTypes.array,
    addListToRecommended: PropTypes.func.isRequired,
    removeListFromRecommended: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      searchList: '',
      listStatus: 2,
      typing: false,
      typingTimeout: 0,
      isRestrict: false,
      sortBy: null,
      sortOrder: 'DESC'
    }
  }

  async componentDidMount() {
    const { demoRestrictionEncode } = this.props;
    const isRestrict = await demoRestrictionEncode();
    this.setState({ isRestrict });
  }


  paginationData = (currentPage) => {
    const { getAllListings: { refetch } } = this.props;
    const { sortBy, sortOrder } = this.state;
    let variables = { currentPage, sortBy, sortOrder };
    this.setState({ currentPage });
    refetch(variables);
  }

  handleSort = (columnName) => {
    const { getAllListings: { refetch } } = this.props;
    const { sortBy, sortOrder } = this.state;

    let newSortOrder = 'DESC';
    if (sortBy === columnName && sortOrder === 'DESC') {
      newSortOrder = 'ASC';
    }

    this.setState({ sortBy: columnName, sortOrder: newSortOrder });

    let variables = {
      currentPage: 1,
      sortBy: columnName,
      sortOrder: newSortOrder
    };
    refetch(variables);
  }

  handleClick = (searchList) => {
    const { getAllListings: { refetch } } = this.props;
    const { currentPage } = this.state;
    let variables = {
      currentPage: 1,
      searchList: searchList
    };
    this.setState({ currentPage: 1 });
    refetch(variables);
  }

  handleSearchChange = (e) => {
    const self = this;
    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }
    self.setState({
      searchList: e.target.value,
      typing: false,
      typingTimeout: setTimeout(function () {
        self.handleClick(self.state.searchList);
      }, 450)
    });
  }

  deleteListing = async (id, type) => {
    const { removeListing, getAllListings: { refetch, getAllListings }, demoRestriction } = this.props;
    const { currentPage } = this.state;
    let variables = { currentPage: currentPage > 1 && getAllListings?.usersData?.length == 1 ? currentPage - 1 : currentPage };
    const isRestrict = await demoRestriction({ restrictType: 'listing', restrictValue: id });
    if (isRestrict) return;
    await removeListing(id, type);
    this.setState({ currentPage: variables?.currentPage });
    await refetch(variables);
  }

  handleFilterChange = (listStatus) => {
    const { getAllListings: { refetch }, changeFilterSettings } = this.props;
    const { currentPage, searchList } = this.state;
    changeFilterSettings(currentPage, searchList, listStatus)
    let variables = { currentPage: 1, searchList, listStatus };
    this.setState({ currentPage: 1, listStatus })
    refetch(variables);
  }

  thead = () => {
    const { formatMessage } = this.props.intl;
    const { sortBy, sortOrder } = this.state;

    const getSortIcon = (columnName) => {
      if (sortBy !== columnName) {
        return ' ↕️';
      }
      return sortOrder === 'ASC' ? ' 🔼' : ' 🔽';
    };

    return [
      { data: formatMessage(messages.idLabel) },
      { data: formatMessage(messages.adminTitleLabel) },
      { data: formatMessage(messages.hostNameLabel) },
      { data: formatMessage(messages.hostEmailLabel) },
      { data: formatMessage(messages.phoneNumber) },
      { data: formatMessage(messages.address) },
      { data: formatMessage(messages.city) },
      { data: formatMessage(messages.stateLabel) },
      {
        data: (
          <span
            onClick={() => this.handleSort('createdAt')}
            style={{ cursor: 'pointer', userSelect: 'none' }}
          >
            {formatMessage(messages.createdDate)}{getSortIcon('createdAt')}
          </span>
        )
      },
      { data: formatMessage(messages.recommendLabel) },
      { data: formatMessage(messages.publishedLabel) },
      { data: formatMessage(messages.ready) },
      { data: formatMessage(messages.editLabel) },
      { data: formatMessage(messages.viewLabel) },
      { data: formatMessage(messages.delete) }
    ]
  }

  tbody = (props) => {
    const { getAllListings: { getAllListings }, removeListFromRecommended, addListToRecommended } = props;
    const { currentPage, searchList, listStatus, isRestrict } = this.state;
    const { formatMessage } = props.intl;

    return getAllListings?.usersData?.map((value, key) => {
      let viewListing = "/rooms/" + value?.id, editListing = '/become-a-host/' + value.id + '/home';
      let isPublished = value?.isPublished ? 'Yes' : 'No', isReady = value?.isReady ? 'Yes' : 'No';
      let phoneNumber = value?.user?.profile?.phoneNumber ? decode(value?.user?.profile?.phoneNumber) : null;
      let googleMapsUrl = value?.lat && value?.lng ? `https://www.google.com/maps?q=${value.lat},${value.lng}` : null;

      return {
        id: key,
        data: [
          { data: value?.id },
          { data: value?.title ? value?.title : <>-</> },
          { data: value?.user?.profile?.firstName },
          { data: !isRestrict ? decode(value?.user?.encryptEmail) : censorEmail(decode(value?.user?.encryptEmail)) },
          { data: value?.user?.profile?.countryCode && phoneNumber && value?.user?.profile?.countryCode + phoneNumber },
          {
            data: googleMapsUrl ? (
              <a href={googleMapsUrl} target="_blank" rel="noopener noreferrer">
                View Maps
              </a>
            ) : <>-</>
          },
          { data: value?.city },
          { data: value?.state },
          { data: moment(parseInt(value?.createdAt)).format('DD/MM/YYYY') },
          {
            data: <a href="javascript:void(0)" onClick={() => value?.recommend ? removeListFromRecommended(value?.id, currentPage, searchList, listStatus) : addListToRecommended(value.id, currentPage, searchList, listStatus)} >
              {value?.recommend ? <FormattedMessage {...messages.remove} /> : <FormattedMessage {...messages.setLabel} />}
            </a>
          },
          { data: isPublished },
          { data: isReady },
          {
            data: <a href={editListing} target="_blank" >
              <FormattedMessage {...messages.editLabel} />
            </a>
          },
          {
            data: <a href={viewListing} target="_blank" >
              <FormattedMessage {...messages.viewLabel} />
            </a>
          },
          {
            data: <Confirm
              onConfirm={() => this.deleteListing(value?.id, "admin")}
              body={formatMessage(messages.areYouSureDeleteWishList)}
              confirmText={formatMessage(messages.confirmDelete)}
              cancelText={formatMessage(messages.cancel)}
              title={formatMessage(messages.deletingListingTitle)}
            >
              <a href="javascript:void(0)"><FormattedMessage {...messages.delete} /></a>
            </Confirm>
          }
        ]
      }
    })
  }
  listFilters = () => {
    const { formatMessage } = this.props.intl;
    return [
      { value: "2", label: formatMessage(messages.allLabel) },
      { value: "1", label: formatMessage(messages.listed) },
      { value: "0", label: formatMessage(messages.unListed) }
    ]
  }

  render() {
    const { getAllListings: { getAllListings, loading } } = this.props;
    const { currentPage, searchList, listStatus } = this.state;
    const { formatMessage } = this.props.intl;
    return (
      <div>
        {loading && <div><Loader type={"text"} /></div>}

        {!loading && <div>
          <CommonTable
            title={formatMessage(messages.listingsManagement)}
            thead={this.thead}
            tbody={() => this.tbody(this.props)}
            isSearch
            handleSearch={(e) => this.handleSearchChange(e)}
            exportURL={getAllListings?.usersData?.length > 0 ? `/export-admin-data?type=listings&listStatus=${listStatus}&keyword=${searchList}` : null}
            handleFilterChange={this.handleFilterChange}
            listFilters={this.listFilters()}
          />
          <div>
            {
              getAllListings?.usersData?.length > 0 && <div>
                <CustomPagination
                  total={getAllListings.count}
                  currentPage={currentPage}
                  defaultCurrent={1}
                  defaultPageSize={10}
                  change={this.paginationData}
                  paginationLabel={formatMessage(messages.lists)}
                  isScroll
                />
              </div>
            }
          </div>
        </div>}
      </div>
    );
  }

}

const mapState = (state) => ({});

const mapDispatch = {
  removeListing,
  addListToRecommended,
  removeListFromRecommended,
  changeFilterSettings,
  demoRestriction,
  demoRestrictionEncode
};
export default compose(
  injectIntl,
  withStyles(s),
  connect(mapState, mapDispatch),
  withQuery(listingsQuery, {
    name: 'getAllListings',
    options: {
      variables: {
        currentPage: 1,
        searchList: '',
        listStatus: 2,
        sortBy: null,
        sortOrder: 'DESC'
      },
      fetchPolicy: 'network-only',
      ssr: false
    }
  })
)(ListingManagement);